export default __webpack_public_path__ + "static/media/kitap8.82e3977d.jpg";